export default "__VITE_ASSET__BUBLb37x__"